import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";

// Remove "includeOnProduct" filter so that child variants return ALL attributes.
// Parent variants still apply the filter via LoadProductByPath.
const CustomPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.apiParameter = {
        productId: props.parameter.productId,
        pageSize: 1000,
        expand: ["content", "documents", "specifications", "attributes", "badges"],
    };
};

replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);
